import { render } from "./DataKaryawan.vue?vue&type=template&id=30805924&scoped=true"
import script from "./DataKaryawan.vue?vue&type=script&lang=js"
export * from "./DataKaryawan.vue?vue&type=script&lang=js"

import "./DataKaryawan.vue?vue&type=style&index=0&id=30805924&scoped=true&lang=css"
import "./DataKaryawan.vue?vue&type=style&index=1&id=30805924&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\HRIS BCK\\digajiin_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30805924"]])

export default __exports__